export const HEADING_COLUMNS_WHITELIST = {
  football: ['teamName', 'matches', 'win', 'draw', 'lost', 'pts'],
  global_basketball: ['teamName', 'matches', 'win', 'lost', 'percentage', 'pf', 'pa', 'difference' ],
  nba: ['teamName', 'matches', 'win', 'lost', 'last10']
}

export const HEADING_FALLBACK_CELLS = ['Team', 'MP', 'W', 'D', 'L', 'PT']

export const TABLE_FALLBACK_DATA = [
  { id: '1' },
  { id: '2' },
  { id: '3' },
  { id: '4' },
  { id: '5' },
  { id: '6' },
  { id: '7' },
  { id: '8' },
  { id: '9' },
  { id: '10' },
  { id: '11' },
  { id: '12' },
  { id: '13' },
  { id: '14' },
  { id: '15' },
  { id: '16' },
  { id: '17' },
  { id: '18' },
  { id: '19' },
  { id: '20' },
  { id: '21' },
  { id: '22' },
  { id: '23' },
  { id: '24' },
  { id: '25' },
  { id: '26' },
  { id: '27' },
  { id: '28' },
  { id: '29' },
  { id: '30' },
  { id: '31' },
  { id: '32' },
  { id: '33' },
  { id: '34' },
  { id: '35' },
  { id: '36' },
  { id: '37' },
  { id: '38' },
  { id: '39' },
  { id: '40' },
  { id: '41' },
  { id: '42' },
  { id: '43' },
  { id: '44' },
  { id: '45' },
  { id: '46' },
  { id: '47' },
  { id: '48' },
  { id: '49' },
  { id: '50' }
]

export const mapFullNameToShortName = {
  'Atlanta Hawks': 'ATL',
  'Brooklyn Nets': 'BKN',
  'Boston Celtics': 'BOS',
  'Charlotte Hornets': 'CHA',
  'Chicago Bulls': 'CHI',
  'Cleveland Cavaliers': 'CLE',
  'Dallas Mavericks': 'DAL',
  'Denver Nuggets': 'DEN',
  'Detroit Pistons': 'DET',
  'Golden State Warriors': 'GSW',
  'Houston Rockets': 'HOU',
  'Indiana Pacers': 'IND',
  'LA Clippers': 'LAC',
  'Los Angeles Lakers': 'LAL',
  'Memphis Grizzlies': 'MEM',
  'Miami Heat': 'MIA',
  'Milwaukee Bucks': 'MIL',
  'Minnesota Timberwolves': 'MIN',
  'New Orleans Pelicans': 'NOP',
  'New York Knicks': 'NYK',
  'Oklahoma City Thunder': 'OKC',
  'Orlando Magic': 'ORL',
  'Philadelphia 76ers': 'PHI',
  'Phoenix Suns': 'PHX',
  'Portland Trail Blazers': 'POR',
  'Sacramento Kings': 'SAC',
  'San Antonio Spurs': 'SAS',
  'Toronto Raptors': 'TOR',
  'Utah Jazz': 'UTA',
  'Washington Wizards': 'WAS'
}


export const mapSportRadarTeamNameToCustomNames = {
  'Real Madrid': {
    shortName: 'RMB',
    abbreviatedName: 'Real',
    fullName: 'Real Madrid'
  },
  'Panathinaikos BC': {
    shortName: 'PAO',
    abbreviatedName: 'Panathinaikos',
    fullName: 'Panathinaikos AKTOR Athens'
  },
  'AS Monaco': {
    shortName: 'ASM',
    abbreviatedName: 'Monaco',
    fullName: 'AS Monaco'
  },
  'FC Barcelona': {
    shortName: 'BAR',
    abbreviatedName: 'Barcelona',
    fullName: 'FC Barcelona'
  },
  'BC Olympiakos Piraeus': {
    shortName: 'OLY',
    abbreviatedName: 'Olympiacos',
    fullName: 'Olympiacos Piraeus'
  },
  'Fenerbahce Istanbul': {
    shortName: 'FBB',
    abbreviatedName: 'Fenerbahce',
    fullName: 'Fenerbahce Beko Istanbul'
  },
  'Maccabi Tel-Aviv': {
    shortName: 'MTA',
    abbreviatedName: 'Maccabi',
    fullName: 'Maccabi Playtika Tel Aviv'
  },
  'Baskonia Vitoria-Gasteiz': {
    shortName: 'BKN',
    abbreviatedName: 'Baskonia',
    fullName: 'Baskonia Vitoria-Gasteiz'
  },
  'Anadolu Efes SK': {
    shortName: 'EFS',
    abbreviatedName: 'Anadolu Efes',
    fullName: 'Anadolu Efes Istanbul'
  },
  'Virtus Bologna': {
    shortName: 'VIR',
    abbreviatedName: 'Virtus',
    fullName: 'Virtus Segafredo Bologna'
  },
  'Paris Basketball': {
    shortName: 'PBB',
    abbreviatedName: 'Paris',
    fullName: 'Paris Basketball'
  },
  'KK Partizan Belgrade': {
    shortName: 'PAR',
    abbreviatedName: 'Partizan',
    fullName: 'Partizan Mozzart Bet Belgrade'
  },
  'Olimpia Milano': {
    shortName: 'EA7',
    abbreviatedName: 'Milan',
    fullName: 'EA7 Emporio Armani Milan'
  },
  'Alba Berlin': {
    shortName: 'BER',
    abbreviatedName: 'ALBA',
    fullName: 'ALBA Berlin'
  },
  'ASVEL Lyon-Villeurbanne': {
    shortName: 'ASV',
    abbreviatedName: 'ASVEL',
    fullName: 'LDLC ASVEL Villeurbanne'
  },
  'BC Zalgiris Kaunas': {
    shortName: 'ZAL',
    abbreviatedName: 'Zalgiris',
    fullName: 'Zalgiris Kaunas'
  },
  'KK Crvena zvezda Belgrade': {
    shortName: 'CZV',
    abbreviatedName: 'Crvena Zvezda',
    fullName: 'Crvena Zvezda Meridianbet Belgrade'
  },
  'Bayern Munich': {
    shortName: 'BAY',
    abbreviatedName: 'Bayern',
    fullName: 'FC Bayern Munich'
  }
}